import jQueryBridget from 'jquery-bridget';
import Isotope from 'isotope-layout';

export default {
  init() {
    jQueryBridget( 'isotope', Isotope, $ );

    var hashFilter = ['.status-coming-soon', '.status-now-selling'];

    function checkHashFilter() {
      hashFilter = getHashFilter();
      var newFilter = $('[data-filter-name] option:selected').val();

      if ( hashFilter === '' ) {
        hashFilter = ['.status-coming-soon', '.status-now-selling'];
      }

      if ( newFilter !== '*' && newFilter !== '') {
        hashFilter = hashFilter.map(function(element) {
          return newFilter + element;
        });
        // newFilter = hashFilter + ', ' + newFilter;
      }

      newFilter = hashFilter.join();

      $grid.isotope({
        filter: newFilter,
      });
    }

    function getHashFilter() {
      var newFilter = '';
      var hash = location.hash;
      var matches = hash.match( /(status-[^&/\\]+)/i );

      if (matches) {
        if ( matches[1] !== 'all' ) {
          newFilter = [ '.' + matches[1] ];
        }
      }

      return newFilter;
    }

    $('[data-filter-name]').on('change', function() {
      checkHashFilter();
    });

    $(window).on('hashchange', checkHashFilter);

    $('.filter-top-bar-link').on('click', function() {
      $('.filter-top-bar-link').removeClass('active');
      $(this).addClass('active');
    });

    // Set the correct filter class active on load
    if ( getHashFilter() !== '' ) {
      hashFilter = getHashFilter();

      $('a[href="#' + hashFilter[0].substring(1) + '"]').trigger('click');
    }

    var $grid = $('.grid').isotope({
      itemSelector: '.grid-item',
      layoutMode: 'fitRows',
      filter: hashFilter.join(),
    });

  },
  finalize() {

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-community-archive.js